"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthorizationHeaders = void 0;
const exports_1 = require("../exports");
const logging_1 = require("../logging");
const getHeaders = (authToken) => ({
    Authorization: `Bearer ${authToken}`,
});
/**
 * Get authorization headers for the currently authenticated user.
 *
 * Will automatically pull and use current authorization token unless `authToken` is provided.
 *
 * @param options - options for getting the authorization headers
 */
const getAuthorizationHeaders = async (options) => {
    const { authToken } = options || {};
    if (authToken) {
        return getHeaders(authToken);
    }
    const authTokenResult = await (0, exports_1.getAuthTokenData)();
    if (!authTokenResult.data) {
        // under recommended config, this should trigger sign out redirect, so we just log a warning
        (0, logging_1.warn)('Unable to get auth token data. Returning empty authorization headers.', authTokenResult);
        return {};
    }
    return getHeaders(authTokenResult.data.rawToken);
};
exports.getAuthorizationHeaders = getAuthorizationHeaders;
